import { consumeTokenFromCookie, getAuthToken, setAuthToken } from '@/lib/api/authToken'
import { Purchases, initRevenueCat } from '@/lib/revenuecat'
import { registerApp, WECHAT_APP_ID } from '@/lib/wechat'
import { initOnboardingThunk } from '@/redux/slices/onboardingSlice'
import { initSession } from '@/redux/slices/sessionSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { SplashScreen } from 'expo-router'
import Cookies from 'js-cookie'
import { useCallback, useEffect } from 'react'
import { Platform } from 'react-native'

SplashScreen.preventAutoHideAsync()

// Redirect to desktop version if user has previously switched to it
if (Platform.OS === 'web' && typeof document !== 'undefined' && Cookies.get('platform') === 'web') {
  const apiBaseUrl = process.env.EXPO_PUBLIC_API_BASE_URL
  if (apiBaseUrl) {
    window.location.href = `${apiBaseUrl}${window.location.pathname}${window.location.search}`
  }
}

export default function InitializeApp() {
  const dispatch = useAppDispatch()

  const sessionInitialized = useAppSelector(state => state.session.initialized)
  const onboardingInitialized = useAppSelector(state => state.onboarding.initialized)
  const currentUser = useAppSelector(state => state.currentUser.user)
  const initialized = sessionInitialized && onboardingInitialized

  const initWechatSDK = useCallback(async () => {
    try {
      const result = await registerApp({ appId: WECHAT_APP_ID })
      console.log('init wechat sdk result', result)
    } catch (error) {
      console.error('failed to register wechat app with error', error)
    }
  }, [])

  useEffect(() => {
    if (Platform.OS === 'ios') {
      initRevenueCat()
    }
    initWechatSDK()
    dispatch(initOnboardingThunk())

    consumeTokenFromCookie()
    // Always dispatch initSession, even if the migration rejects, so startup is never blocked.
    migrateStorageFromCyborgApp().finally(() => {
      dispatch(initSession())
    })
  }, [dispatch, initWechatSDK])

  useEffect(() => {
    if (currentUser?.id && Platform.OS === 'ios') {
      Purchases.logIn(String(currentUser.id))
    }
  }, [currentUser?.id])

  useEffect(() => {
    if (initialized) {
      SplashScreen.hideAsync()
    }
  }, [initialized])

  return null
}

const CYBORG_APP_TOKEN_KEY = 'CURRENT_USER_TOKEN'

async function migrateStorageFromCyborgApp() {
  // Keep getAuthToken inside the try: storage access can throw on web (blocked localStorage),
  // and an unhandled rejection here would prevent initSession from ever dispatching, blocking
  // startup (NEXT-APP-1W).
  try {
    if (getAuthToken()) return

    const token = await AsyncStorage.getItem(CYBORG_APP_TOKEN_KEY)
    if (!token) return

    console.log('found user token of cyborg app')
    setAuthToken(token)
    AsyncStorage.clear()
  } catch (error) {
    console.error(error)
  }
}
